<template>
  <div>
    <form>
      <b-row class="toolbar-ptc">
        <b-col>
          <router-link :to="{ name: 'event_list', params: { search: search } }" class="btn btn-ptc1" tag="button">返回</router-link>
        </b-col>
        <b-col class="text-center title">行銷活動 / 行銷活動管理 / {{action==2?'新增':'修改'}}</b-col>
        <b-col>
          <div class="text-right">
            <button type="button" class="btn btn-preview" @click="preview">預覽</button>
            <button type="button" class="btn btn-save" @click="save(0)">儲存</button>
            <button type="button" class="btn btn-publish" v-if="status==0&&action==1&&FunctionPermission>2" @click="save(1)">發佈</button>
          </div>
        </b-col>
      </b-row>

      <div id="func-content">
        <b-card class="bg-default-card">
          <div class="row">
            <div class="col-lg-12">
              <div class="col-lg-6">
                <div class="form-group">
                  <label class="control-label">活動類別</label>
                  <select class="form-control" v-model="ddl_type" :disabled="birthday_event || (status==1&&action==1)">
                    <option value="0" disabled>請選擇活動類別</option>
                    <option value="1">最新活動</option>
                    <option value="2">新開幕</option>
                    <option value="3">APP公告</option>
                  </select>
                  <div class="text-danger" v-if="valid_ddl_type&&ddl_type==0">{{valid_ddl_type}}</div>
                </div>

                <!-- 品牌多選 -->
                <div class="form-group">
                  <label class="control-label d-block">品牌</label>
                  <b-form-checkbox-group v-model="brand_codes" class="d-flex flex-wrap">
                    <b-form-checkbox value="MWD" class="mr-3">麥味登</b-form-checkbox>
                    <b-form-checkbox value="CM" class="mr-3">炸雞大獅</b-form-checkbox>
                    <b-form-checkbox value="REAL" class="mr-3">Real</b-form-checkbox>
                    <b-form-checkbox value="SJ">涮金鍋</b-form-checkbox>
                  </b-form-checkbox-group>
                  <div class="text-danger" v-if="valid_brand_code && brand_codes.length===0">{{ valid_brand_code }}</div>
                </div>
              </div>

              <div class="col-lg-12">
                <div class="form-group">
                  <label class="control-label">標題 (建議字數為10個中文字)</label>
                  <input type="text" class="form-control" v-model.trim="title" maxlength="100" placeholder="請輸入行銷活動標題">
                  <div class="text-danger" v-if="valid_title&&!title">{{valid_title}}</div>
                </div>
              </div>

              <div class="col-lg-12">
                <label class="control-label">內容</label>
                <vue-editor v-model="repl_content" :editor-toolbar="customToolbar"></vue-editor>
                <div class="text-danger" v-if="valid_content&&!repl_content">{{valid_content}}</div>
              </div>

              <div class="col-lg-12 mt-3">
                <div class="row">
                  <div class="col-lg-6">
                    <div class="form-group">
                      <label class="control-label">活動列表圖示上傳</label>
                      <div class="form-group">
                        <input type="file" class="upload_input" id="pic" ref="inputer" multiple @change="handleFileChange($event, 1)">
                        <label class="upload_block pic" for="pic">
                          <span class="upload_icon">➕</span>
                          <img class="upload_img" :src="cover_file==undefined? cover_url : cover_url">
                        </label>
                        <span class="text-danger" v-if="valid_cover_url">{{valid_cover_url}}</span>
                        <div class="text-red" style="color: #ff0000">※限制上傳一張圖片，建議尺寸為675x260</div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div class="form-group">
                      <label class="control-label">活動內頁圖示上傳</label>
                      <div class="form-group">
                        <input type="file" class="upload_input" id="pic2" ref="inputer2" multiple @change="handleFileChange($event, 2)">
                        <label class="upload_block pic2" for="pic2">
                          <span class="upload_icon">➕</span>
                          <img class="upload_img" :src="content_file==undefined? content_url : content_url">
                        </label>
                        <span class="text-danger" v-if="valid_content_url">{{valid_content_url}}</span>
                        <div class="text-red" style="color: #ff0000">※限制上傳一張圖片，建議尺寸為750x750</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-12">
                <div class="row">
                  <div class="col-lg-6">
                    <div class="form-group">
                      <label class="control-label">開始日期</label>
                      <input type="date" class="form-control" v-model="sdate" :min="today" max="9999-12-31" :disabled="birthday_event || (action==1&&status==1&&old_sdate<=today)">
                      <div class="text-danger" v-if="valid_sdate">{{valid_sdate}}</div>
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div class="form-group">
                      <label class="control-label">結束日期</label>
                      <input type="date" class="form-control" v-model="edate" :min="action==2?(sdate?sdate:today):''" max="9999-12-31">
                      <div class="text-danger" v-if="valid_edate">{{valid_edate}}</div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-12" v-if="!birthday_event">
                <div class="form-group">
                  <label class="control-label">電腦版行銷活動網址</label>
                  <input type="text" class="form-control" v-model="link" placeholder="http://">
                  <div class="text-danger" v-if="valid_link">{{valid_link}}</div>
                </div>
              </div>

              <div class="col-lg-12 mt-3">
                <div class="row" v-if="!birthday_event">
                  <div class="col-lg-2">
                    <b-form-checkbox class="mt-2" v-model="send_message" :disabled="action==1&&status==1">推播訊息</b-form-checkbox>
                  </div>
                  <div class="col-lg-7">
                    <input type="text" class="form-control" :disabled="!send_message || (action==1&&status==1)" v-model.trim="message" maxlength="200" placeholder="請輸入推播訊息內容">
                    <div class="text-danger" v-if="send_message&&valid_message&&!message">{{valid_message}}</div>
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="col-lg-4" v-if="!birthday_event">
                    <b-form-checkbox v-model="to_event">連結到會員集點任務列表</b-form-checkbox>
                  </div>
                  <div class="col-lg-7" v-show="ddl_type==3">
                    <div class="row">
                      <label class="control-label mt-2">活動設定</label>
                      <div class="col-lg-7">
                        <select class="form-control" :disabled="(!birthday_event&&action==1&&status==1)" v-model="eventType" @change="ddlEventTypeChange">
                          <option value=0>無</option>
                          <option value=1>門市消費贈點</option>
                          <option value=2>APP促銷活動</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- 會員贈點活動設定區塊 -->
              <div class="col-lg-12 mt-3" v-if="eventType!=0&&ddl_type==3">
                <form class="form-horizontal form-validation" v-if="!birthday_event">
                  <fieldset>
                    <legend>會員贈點活動設定</legend>
                    <div class="col-lg-12">
                      <fieldset>
                        <legend>活動生效日</legend>
                        <b-form-radio-group v-model="effect_type">
                          <div class="row">
                            <div class="col-lg-12">
                              <b-form-radio value="1" :disabled="action==1&&status==1">指定日期</b-form-radio>
                            </div>
                            <div class="col-lg-4 mt-2">
                              <input type="date" class="form-control" v-model="design_date" :min="sdate?sdate:today" :max="edate?edate:9999-12-31" :disabled="!(effect_type==1) || (action==1&&status==1)">
                              <div class="text-danger" v-if="effect_type==1&&valid_design_date">{{valid_design_date}}</div>
                            </div>
                            <div class="col-lg-12 mt-3">
                              <b-form-radio value="2" :disabled="action==1&&status==1">指定區間</b-form-radio>
                            </div>
                            <div class="col-lg-4 mt-2">
                              <input type="date" class="form-control" v-model="effect_s_date" :min="sdate?sdate:today" :max="edate?edate:9999-12-31" :disabled="!(effect_type==2) || (action==1&&status==1)">
                              <div class="text-danger" v-if="effect_type==2&&valid_effect_s_date">{{valid_effect_s_date}}</div>
                            </div>
                            <label class="mt-3">至</label>
                            <div class="col-lg-4 mt-2">
                              <input type="date" class="form-control" v-model="effect_e_date" :min="effect_s_date?effect_s_date:sdate" :max="edate?edate:9999-12-31" :disabled="!(effect_type==2)">
                              <div class="text-danger" v-if="effect_type==2&&valid_effect_e_date">{{valid_effect_e_date}}</div>
                            </div>
                          </div>
                        </b-form-radio-group>
                      </fieldset>
                    </div>

                    <div class="col-lg-12">
                      <fieldset>
                        <legend>贈點條件</legend>
                        <b-form-radio-group v-model="member_type">
                          <div class="row">
                            <div class="col-lg-12">
                              <b-form-radio value="1" :disabled="action==1&&status==1">全部會員</b-form-radio>
                              <b-form-radio value="2" :disabled="action==1&&status==1">正式會員</b-form-radio>
                            </div>
                          </div>
                        </b-form-radio-group>
                      </fieldset>
                    </div>

                    <div class="col-lg-12">
                      <fieldset>
                        <legend>贈點方式</legend>
                        <b-form-radio-group v-model="eventFuncValue" :disabled="action==1&&status==1">
                          <b-form-radio value=1 :disabled="action==1&&status==1">贈點</b-form-radio>
                          <b-form-radio-group v-model="give_type">
                            <div class="row">
                              <div class="col-lg-1"></div>
                              <div class="col-lg-11">
                                <b-form-radio value="1" :disabled="eventFuncValue != 1 || (action==1&&status==1)">
                                  <div class="row" style="margin-left: 2px">
                                    滿&nbsp;
                                    <input type="number" :disabled="!(give_type==1) || eventFuncValue!=1 || (action==1&&status==1)" class="form-control col-md-4" style="margin-top: -3px" v-model="certain_amount" min="0" max="9999">&nbsp;元加贈&nbsp;
                                    <input type="number" :disabled="!(give_type==1) || eventFuncValue!=1 || (action==1&&status==1)" class="form-control col-md-4" style="margin-top: -3px" v-model="reward_bonus" min="0" max="9999">&nbsp;點
                                  </div>
                                  <div class="text-danger" v-if="give_type==1&&valid_bonus">{{valid_bonus}}</div>
                                </b-form-radio>
                              </div>
                              <div class="col-lg-1"></div>
                              <div class="col-lg-11 mt-3">
                                <b-form-radio value="2" :disabled="eventFuncValue != 1 || (action==1&&status==1)">
                                  <div class="row" style="margin-left: 2px">
                                    點數&nbsp;
                                    <input type="number" :disabled="!(give_type==2) || eventFuncValue!=1 || (action==1&&status==1)" class="form-control col-md-5" style="margin-top: -3px" v-model="multiple" min="0" max="9999">&nbsp;倍送
                                  </div>
                                  <div class="text-danger" v-if="give_type==2&&valid_bonus">{{valid_bonus}}</div>
                                </b-form-radio>
                              </div>
                            </div>
                          </b-form-radio-group>
                        </b-form-radio-group>
                      </fieldset>
                    </div>

                    <div class="col-lg-12" v-if="eventType==1">
                      <fieldset>
                        <legend>設定區域</legend>
                        <b-form-radio-group v-model="store_type">
                          <div class="row">
                            <div class="col-lg-12">
                              <b-form-radio value="1" :disabled="action==1&&status==1">全門市</b-form-radio>
                            </div>
                            <div class="col-lg-2 mt-3">
                              <b-form-radio value="2" :disabled="action==1&&status==1">特定門市</b-form-radio>
                            </div>
                            <div class="col-lg-2 mt-2">
                              <select class="form-control" :disabled="!(store_type==2) || (action==1&&status==1)" v-model="ddl_city" @change="ddlCityChange">
                                <option value="0" disabled>請選擇地區</option>
                                <option v-for="x in stores" :value="x" :key="x.City">{{x.City}}</option>
                              </select>
                            </div>
                            <div class="col-lg-2 mt-2">
                              <select class="form-control" :disabled="!(store_type==2) || (action==1&&status==1)" v-model="ddl_district" @change="ddlDistrictChange">
                                <option value="0" disabled>請選擇行政區</option>
                                <option v-for="x in ddl_city.Districts" :value="x" :key="x.District">{{x.District}}</option>
                              </select>
                            </div>
                            <div class="text-danger" style="margin-top: 15px" v-if="store_type==2&&valid_stores">{{valid_stores}}</div>

                            <div class="col-lg-12 row mt-3" v-show="store_type==2">
                              <div class="col-lg-3">
                                <b-form-group>
                                  <template slot="label">
                                    <b-form-checkbox v-if="ddl_city==0" disabled>請選擇地區</b-form-checkbox>
                                    <b-form-checkbox v-else v-model="chk_all_selected" @change="toggleAll">{{ddl_district.District}}</b-form-checkbox>
                                  </template>
                                  <b-form-checkbox-group v-model="multiple_stores" style="height: 200px; overflow: auto" stacked>
                                    <b-form-checkbox v-for="x in ddl_district.Stores" :value="x" :key="x.ID">{{x.Name}}</b-form-checkbox>
                                  </b-form-checkbox-group>
                                </b-form-group>
                              </div>
                              <div class="col-lg-1">
                                <button type="button" class="btn btn-ptc1" style="margin:100px auto;" :disabled="action==1&&status==1" @click="addMultStores">加入</button>
                              </div>
                              <div class="col-lg-8 row box1color">
                                <div class="my-scrollbar">
                                  <div class="row">
                                    <div class="col-lg-3" v-for="s in selected_stores" :key="s.ID">
                                      <b-button class="btn btn-outline-light mt-1" :disabled="action==1&&status==1" @click="delStore(s)"><span class="fa fa-times"></span></b-button>{{s.Name}}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </b-form-radio-group>
                      </fieldset>
                    </div>
                  </fieldset>
                </form>

                <!-- 生日禮活動設定 -->
                <form class="form-horizontal form-validation" v-else>
                  <fieldset>
                    <legend>生日禮贈點活動設定</legend>
                    <div class="col-lg-12">
                      <fieldset>
                        <legend>活動生效日</legend>
                        <b-form-radio-group v-model="effect_type">
                          <div class="row">
                            <div class="col-lg-12">
                              <b-form-radio value="3">當日</b-form-radio>
                              <b-form-radio value="4">當月</b-form-radio>
                            </div>
                          </div>
                        </b-form-radio-group>
                      </fieldset>
                    </div>

                    <div class="col-lg-12">
                      <fieldset>
                        <legend>贈點方式</legend>
                        <b-form-radio-group v-model="give_type">
                          <div class="row">
                            <div class="col-lg-12">
                              <b-form-radio value="1">
                                <div class="row" style="margin-left: 2px">
                                  滿&nbsp;
                                  <input type="number" :disabled="!(give_type==1)" class="form-control col-md-3" style="margin-top: -3px" v-model="certain_amount" min="0" max="9999">&nbsp;元加贈&nbsp;
                                  <input type="number" :disabled="!(give_type==1)" class="form-control col-md-3" style="margin-top: -3px" v-model="reward_bonus" min="0" max="9999">&nbsp;點
                                </div>
                                <div class="text-danger" v-if="give_type==1&&valid_bonus">{{valid_bonus}}</div>
                              </b-form-radio>
                            </div>
                            <div class="col-lg-12 mt-3">
                              <b-form-radio value="2">
                                <div class="row" style="margin-left: 2px">
                                  點數&nbsp;
                                  <input type="number" :disabled="give_type==1" class="form-control col-md-3" style="margin-top: -3px" v-model="multiple" min="0" max="9999">&nbsp;倍送
                                </div>
                                <div class="text-danger" v-if="give_type!=1&&valid_bonus">{{valid_bonus}}</div>
                              </b-form-radio>
                            </div>
                          </div>
                        </b-form-radio-group>
                      </fieldset>
                    </div>
                  </fieldset>
                </form>
              </div>

            </div>
          </div>
        </b-card>

        <!-- 預覽畫面Modal -->
        <b-modal ref="mdDetail" hide-footer :title="title">
          <b-container fluid>
            <form>
              <div class="row mb-3">
                <div class="col-md-12">
                  <img class="col-md-12" :src="content_file==undefined? content_url : content_url">
                </div>
                <div class="col-md-12 mt-3" style="word-break: break-all;" v-html="repl_content"></div>
              </div>
              <hr>
              <div class="float-right">
                <b-btn variant="secondary" @click="close">關閉</b-btn>
              </div>
            </form>
          </b-container>
        </b-modal>

        <!-- Double Check Modal -->
        <b-modal ref="mdCheck" hide-footer title="行銷活動變更">
          <b-container fluid>
            <form>
              <div class="row mb-3">
                <label class="control-label" v-if="action==2">確定新增此則活動 ?</label>
                <label class="control-label" v-else-if="status==0&&new_status==1">確定發佈此則活動 ?</label>
                <label class="control-label" v-else>確定儲存此則活動 ?</label>
              </div>
              <div class="float-right">
                <b-btn variant="primary" @click="confirm">確定</b-btn>
                <b-btn variant="secondary" @click="cancel">取消</b-btn>
              </div>
            </form>
          </b-container>
        </b-modal>

        <!-- Delete or Down Check Modal -->
        <b-modal ref="mdDelete" hide-footer title="行銷活動刪除">
          <b-container fluid>
            <form>
              <div class="row mb-3">
                <label class="control-label" v-if="!birthday_event">確定<span style="color: #ff0000">{{status==0?'刪除':'下架'}}</span>此則活動 ?</label>
                <label class="control-label" v-else>確定<span style="color: #ff0000">停用</span>生日禮活動 ?</label>
              </div>
              <div class="float-right">
                <b-btn variant="primary" @click="confirm2">確定</b-btn>
                <b-btn variant="secondary" @click="cancel2">取消</b-btn>
              </div>
            </form>
          </b-container>
        </b-modal>

      </div>
    </form>
  </div>
</template>

<script>
import 'codemirror/lib/codemirror.css'
import 'codemirror/theme/monokai.css'
import 'codemirror/keymap/sublime'
import 'codemirror/mode/javascript/javascript.js'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import {getFunctionPermission} from '../../../js/LoginUserFunction.js'
import {API_URL, fileUploadMaxSize} from '../../../store/root.js'
import vueNiceScrollbar from 'vue-nice-scrollbar'
import VueCodeMirror from 'vue-codemirror'
import Multiselect from 'vue-multiselect'
import miniToastr from 'mini-toastr'
import axios from 'axios'
import Vue from 'vue'
import { VueEditor } from 'vue2-editor'
Vue.use(vueNiceScrollbar)
Vue.use(VueCodeMirror)
miniToastr.init()

export default {
  mounted () {
  },
  components: {
    Multiselect,
    VueEditor
  },
  data () {
    return {
      id: 0,
      ddl_type: 1,
      brand_codes: [],
      title: '',
      repl_content: '',
      cover_file: undefined,
      content_file: undefined,
      cover_url: undefined,
      content_url: undefined,
      today: '',
      sdate: '',
      edate: '',
      old_sdate: '',
      old_edate: '',
      link: '',
      send_message: true,
      message: '',
      to_event: true,
      member_reward: false,
      birthday_event: false,
      eventType: 0,
      eventFuncValue: 1,
      discount_type: 3,
      disA_certain_amount: 0,
      disA_amount: 0,
      disD_certain_amount: 0,
      disD_sale: 0,
      effect_type: 1,
      design_date: '',
      effect_s_date: '',
      effect_e_date: '',
      old_design_date: '',
      old_effect_s_date: '',
      member_type: 1,
      give_type: 1,
      certain_amount: 0,
      reward_bonus: 0,
      multiple: 0,
      store_type: 1,
      ddl_city: 0,
      ddl_district: 0,
      stores: [],
      multiple_stores: [],
      selected_stores: [],
      chk_all_selected: false,
      fcm_id: 0,
      status: 0,
      new_status: 1,
      action: 1,
      valid_brand_code: '',
      valid_errMsg: false,
      valid_ddl_type: '',
      valid_title: '',
      valid_content: '',
      valid_cover_url: '',
      valid_content_url: '',
      valid_sdate: '',
      valid_edate: '',
      valid_link: '',
      valid_message: '',
      valid_design_date: '',
      valid_effect_s_date: '',
      valid_effect_e_date: '',
      valid_bonus: '',
      valid_discount: '',
      valid_stores: '',
      search: {}, // 記錄查詢條件
      API_URL: API_URL,
      FunctionPermission: 0,
      code: 'const a = 10',
      customToolbar: [
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        [{ size: ['small', false, 'large', 'huge'] }],
        ['bold', 'italic', 'underline', 'strike'],
        [
          { align: '' },
          { align: 'center' },
          { align: 'right' },
          { align: 'justify' }
        ],
        ['blockquote'],
        [{ list: 'ordered' }, { list: 'bullet' }],
        [{ script: 'sub' }, { script: 'super' }],
        [{ indent: '-1' }, { indent: '+1' }],
        [{ color: [] }, { background: [] }],
        ['link', 'image'],
        ['clean']
      ]
    }
  },
  created () {
    this.FunctionPermission = getFunctionPermission('F05') // 功能權限
    if (this.FunctionPermission < 1) {
      this.$router.push({ name: 'name' })
      return
    } else if (this.FunctionPermission < 2) {
      this.$router.push({ name: 'event_list' })
      return
    }

    var params = this.$route.params
    if (params.item === undefined) {
      this.$router.push({ name: 'event_list' })
      return
    }

    var item = params.item
    this.action = params.action
    this.search = params.search

    this.id = item.ID
    this.ddl_type = item.TargetType
    this.title = item.Title
    this.repl_content = item.Content
    this.cover_url = item.CoverImageURL
    this.content_url = item.ContentImageURL
    this.link = item.Link
    this.send_message = item.ToSendMessage
    this.message = item.Message
    this.to_event = item.ToEvent
    this.member_reward = item.IsMemberReward
    this.eventType = item.RewardType
    this.birthday_event = item.BirthdayEvent
    this.fcm_id = item.FcmID
    this.status = item.Status
    this.updated_at = item.WebUpdatedAt

    // 把 DB 存的 "MWD","CM","REAL" 轉成陣列
    this.brand_codes = this.parseBrandCodeString(item.BrandCode)

    if (this.action === 1) {
      this.sdate = this.old_sdate = item.EnabledAt.substring(0, 10)
      this.edate = this.old_edate = item.DisabledAt.substring(0, 10)
    }
    if (this.eventType !== 0 && this.ddl_type === 3) {
      this.getOneEventReward()
    }

    var date = new Date()
    var year = date.getFullYear()
    var mon = date.getMonth() + 1
    var day = date.getDate()

    if (mon < 10) {
      mon = '0' + mon
    }
    if (day < 10) {
      day = '0' + day
    }
    this.today = year + '-' + mon + '-' + day
  },
  methods: {
    parseBrandCodeString (s) {
      if (!s) return []
      return s.split(',').map(x => x.trim().replace(/^"/, '').replace(/"$/, '')).filter(x => x)
    },
    buildBrandCodeString (arr) {
      if (!arr || !arr.length) return ''
      return arr.map(x => `"${x}"`).join(',')
    },
    preview () {
      if (!this.repl_content.trim() === '') {
        miniToastr.error('請先輸入活動內容')
        return
      }
      this.$refs.mdDetail.show()
    },
    close () {
      this.$refs.mdDetail.hide()
    },
    save (type) {
      if (this.action === 1 && type === 0 && this.edate && this.edate < this.today) {
        this.valid_edate = ''
        this.$refs.mdDelete.show()
      } else {
        this.valid_errMsg = false

        if (this.ddl_type == 0) {
          this.valid_errMsg = true
          this.valid_ddl_type = '活動類別為必選'
        }
        if (!this.brand_codes.length) {
          this.valid_errMsg = true
          this.valid_brand_code = '品牌為必選'
        }
        if (!this.title) {
          this.valid_errMsg = true
          this.valid_title = '標題為必填'
        }

        if (!this.repl_content.trim()) {
          this.valid_errMsg = true
          this.valid_content = '內容為必填'
        }
        if (!this.cover_url) {
          this.valid_errMsg = true
          this.valid_cover_url = '列表圖示為必選'
        }
        if (!this.content_url) {
          this.valid_errMsg = true
          this.valid_content_url = '內頁圖示為必選'
        }
        if (!this.sdate) {
          this.valid_errMsg = true
          this.valid_sdate = '日期格式不正確'
        }
        if (this.status === 0 || this.action === 2) {
          if (this.sdate < this.today) {
            this.valid_errMsg = true
            this.valid_sdate = '開始日期不得小於系統時間'
          }
          this.new_status = type
        } else {
          if (this.old_sdate > this.today && this.sdate < this.today) {
            this.valid_errMsg = true
            this.valid_sdate = '開始日期不得小於系統時間'
          }
          this.new_status = 1
        }
        if (!this.edate) {
          this.valid_errMsg = true
          this.valid_edate = '日期格式不正確'
        } else if (this.edate < this.sdate) {
          this.valid_errMsg = true
          this.valid_edate = '結束日期不得小於開始日期'
        }
        if (!this.link && !this.birthday_event) {
          this.valid_errMsg = true
          this.valid_link = '活動網址為必填'
        } else if (!(this.link.substring(0, 7) === 'http://' || this.link.substring(0, 8) === 'https://') && !this.birthday_event) {
          this.valid_errMsg = true
          this.valid_link = '活動網址請輸入完整路徑http://或https://'
        }
        if (this.send_message && !this.message) {
          this.valid_errMsg = true
          this.valid_message = '推播訊息為必填'
        }

        // 會員贈點活動
        if (this.eventType!=0 && this.ddl_type == 3) {
          if (this.effect_type == 1) {
            if (!this.design_date) {
              this.valid_errMsg = true
              this.valid_design_date = '日期格式不正確'
            } else if (this.design_date < this.sdate || this.design_date > this.edate) {
              this.valid_errMsg = true
              this.valid_design_date = '生效日期不得超出活動日期區間'
            }
          } else if (this.effect_type == 2) {
            if (!this.effect_s_date) {
              this.valid_errMsg = true
              this.valid_effect_s_date = '日期格式不正確'
            } else if (this.effect_s_date < this.sdate || this.effect_s_date > this.edate) {
              this.valid_errMsg = true
              this.valid_effect_s_date = '生效開始日不得超出活動日期區間'
            }
            if (!this.effect_e_date) {
              this.valid_errMsg = true
              this.valid_effect_e_date = '日期格式不正確'
            } else if (this.effect_e_date < this.effect_s_date) {
              this.valid_errMsg = true
              this.valid_effect_e_date = '生效結束日不得小於開始日期'
            } else if (this.effect_e_date > this.edate) {
              this.valid_errMsg = true
              this.valid_effect_e_date = '生效結束日不得超出活動日期區間'
            }
          }
          if (Number(this.eventFuncValue) === 1) {
            if (this.give_type == 1 && (this.certain_amount == 0 || this.reward_bonus == 0)) {
              this.valid_errMsg = true
              this.valid_bonus = '贈點方式不得為零'
            } else if (this.give_type != 1 && this.multiple == 0) {
              this.valid_errMsg = true
              this.valid_bonus = '贈點方式不得為零'
            }
          } else {
            if (this.discount_type == 3 && (this.disA_certain_amount == 0 || this.disA_amount == 0)) {
              this.valid_errMsg = true
              this.valid_discount = '折扣方式不得為零'
            } else if (this.discount_type !== 3 && (this.disD_certain_amount === 0 || this.disD_sale === 0)) {
              this.valid_errMsg = true
              this.valid_discount = '折扣方式不得為零'
            }
          }
          if (this.store_type == 2 && this.selected_stores.length === 0) {
            this.valid_errMsg = true
            this.valid_stores = '至少選擇一間分店'
          }
        }

        if (this.valid_errMsg) {
          this.$parent.verificationErrMsg()
          return
        }
        this.$refs.mdCheck.show()
      }
    },
    cancel () {
      this.$refs.mdCheck.hide()
    },
    confirm () {
      this.$refs.mdCheck.hide()
      this.$parent.Loading = true

      let formData = new FormData()
      formData.append('targetType', this.ddl_type)

      // 多選品牌 -> "MWD","CM","REAL"
      const brandCodesStr = this.buildBrandCodeString(this.brand_codes)
      formData.append('brandCodes', brandCodesStr)

      formData.append('title', this.title)
      formData.append('content', this.repl_content)
      formData.append('image', this.cover_file)
      formData.append('image2', this.content_file)
      formData.append('coverImgUrl', this.cover_url)
      formData.append('contentImgUrl', this.content_url)
      formData.append('link', this.link)
      formData.append('toSendMessage', this.send_message)
      formData.append('message', this.send_message ? this.message : '')
      formData.append('toEvent', this.to_event)
      var isMemberReward = false
      if (Number(this.ddl_type) === 3 && Number(this.eventType) !== 0) {
        isMemberReward = true
      }
      formData.append('isMemberReward', isMemberReward)
      formData.append('rewardType', this.eventType)

      if (this.new_status === 2) {
        if (this.birthday_event) {
          formData.append('sdate', this.sdate)
          formData.append('edate', this.today)
        } else {
          formData.append('sdate', this.old_sdate)
          formData.append('edate', this.old_edate)
        }
      } else {
        formData.append('sdate', this.sdate)
        formData.append('edate', this.edate)
      }

      if (isMemberReward && Number(this.ddl_type) === 3) {
        var dDate = ''
        var sDate = ''
        var eDate = ''
        if (this.effect_type == 1) {
          dDate = this.design_date.replace(/-/g, '')
        } else if (this.effect_type == 2) {
          sDate = this.effect_s_date.replace(/-/g, '')
          eDate = this.effect_e_date.replace(/-/g, '')
        }

        var amount = 0
        var bonus = 0
        var multiple = 0
        var giveDisType = 0
        var disCertainAmount = 0 // 折扣 滿N元
        var discount = 0 // 折扣 折抵N元or折扣%數
        if (Number(this.eventFuncValue) === 1) { // 贈點
          if (Number(this.give_type) === 1) {
            amount = this.certain_amount
            bonus = this.reward_bonus
          } else {
            multiple = this.multiple
          }
          giveDisType = this.give_type
        } else if (Number(this.eventFuncValue) === 2) { // 折扣
          if (Number(this.discount_type) === 3) {
            disCertainAmount = this.disA_certain_amount
            discount = this.disA_amount
          } else {
            disCertainAmount = this.disD_certain_amount
            discount = this.disD_sale
          }
          giveDisType = this.discount_type
        }

        var sID = ''
        if (this.store_type == 2) {
          this.selected_stores.forEach(function (i) {
            sID += i.ID + ','
          })
          sID = sID.substring(0, sID.length - 1)
        }

        formData.append('effectType', this.effect_type)
        formData.append('designDate', dDate)
        formData.append('effectSdate', sDate)
        formData.append('effectEdate', eDate)
        formData.append('memberType', this.member_type)
        formData.append('giveType', giveDisType)
        formData.append('eventType', this.eventFuncValue)
        formData.append('certainAmount', amount)
        formData.append('rewardBonus', bonus)
        formData.append('disCertainAmount', disCertainAmount)
        formData.append('discount', discount)
        formData.append('multiple', multiple)
        formData.append('storeType', Number(this.eventType) === 2 ? 1 : this.store_type)
        formData.append('storeID', sID)
      }

      if (this.action === 2) {
        this.createEvent(formData)
      } else {
        formData.append('id', this.id)
        formData.append('status', this.new_status)
        formData.append('fcmID', this.fcm_id)

        if (this.status === 0 && this.new_status === 1) {
          formData.append('isUP', true)
        }

        this.CheckEtAlreadyModify(formData) // 檢察活動是否已被修改
      }
    },
    cancel2 () {
      this.$refs.mdDelete.hide()
    },
    confirm2 () {
      this.$refs.mdDelete.hide()

      if (this.status === 0) { // 刪除
        this.$parent.Loading = true
        return axios.post(API_URL + '/web/marketing/deleteevent/v1', {
          id: this.id
        })
          .then((response) => {
            this.$store.commit('TOKEN', response.data.jwt)
            this.$parent.Loading = false

            if (response.data.result === '0000') {
              miniToastr.success('行銷活動已刪除')
              this.$router.push({ name: 'event_list', params: { search: this.search } })
            } else if (response.data.result === '0006') {
              this.$parent.logOut(true, true)
            } else {
              miniToastr.error(response.data.message, '資料變更錯誤')
              console.log(response.data.message)
            }
          })
          .catch((error) => {
            this.$parent.Loading = false
            miniToastr.error(error, '資料變更錯誤')
            console.log(error)
          })
      } else { // 下架
        this.new_status = 2
        this.confirm()
      }
    },
    createEvent (formData) {
      return axios.post(API_URL + '/web/marketing/createevent/v1',
        formData
      )
        .then((response) => {
          this.$store.commit('TOKEN', response.data.jwt)
          this.$parent.Loading = false

          if (response.data.result === '0000') {
            miniToastr.success('行銷活動已新增')
            this.search.tabIndex = 0
            this.search.target_type = Number(this.ddl_type)
            this.search.currentPage = 1
            this.$router.push({ name: 'event_list', params: { search: this.search } })
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            miniToastr.error(response.data.message, '資料新增失敗')
            console.log(response.data.message)
          }
        })
        .catch((error) => {
          this.$parent.Loading = false
          miniToastr.error(error, '資料新增失敗')
          console.log(error)
        })
    },
    updateEvent (formData) {
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/marketing/updateevent/v1',
        formData
      )
        .then((response) => {
          this.$store.commit('TOKEN', response.data.jwt)
          this.$parent.Loading = false

          if (response.data.result === '0000') {
            miniToastr.success('行銷活動已變更')
            this.$router.push({ name: 'event_list', params: { search: this.search } })
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            miniToastr.error(response.data.message, '資料變更錯誤')
            console.log(response.data.message)
          }
        })
        .catch((error) => {
          this.$parent.Loading = false
          miniToastr.error(error, '資料變更錯誤')
          console.log(error)
        })
    },
    CheckEtAlreadyModify (formData) {
      return axios.post(API_URL + '/web/marketing/getoneevent/v1', {
        id: this.id
      })
        .then((response) => {
          this.$store.commit('TOKEN', response.data.jwt)
          this.$parent.Loading = false

          if (response.data.result === '0000') {
            if (response.data.data.WebUpdatedAt > this.updated_at) {
              miniToastr.error('活動已被修改，請回到列表重新選取')
            } else {
              this.updateEvent(formData)
            }
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            miniToastr.error('活動已被刪除，請回到列表重新查詢')
          }
        })
        .catch((error) => {
          this.$parent.Loading = false
          miniToastr.error('查無此活動，請回到列表重新查詢')
          console.log(error)
        })
    },
    chkRewardChange (check) {
      if (check) {
        if (this.birthday_event) {
          this.effect_type = 3
          this.member_type = 2
        } else {
          this.getAllStores(1)
        }
      }
    },
    ddlEventTypeChange () {
      if (this.eventType === '1') {
        this.eventFuncValue = 1
        this.getAllStores()
      }
    },
    ddlCityChange () {
      this.ddl_district = this.ddl_city.Districts[0]
      this.ddlDistrictChange()
    },
    ddlDistrictChange () {
      var count = 0
      this.ddl_district.Stores.forEach((i) => {
        var result = this.multiple_stores.map(function (item, index) {
          return item.ID
        }).indexOf(i.ID)
        if (result > -1) {
          count += 1
        }
      })
      if (this.ddl_district.Stores.length === count) {
        this.chk_all_selected = true
      } else {
        this.chk_all_selected = false
      }
    },
    addMultStores () {
      this.valid_stores = false
      this.selected_stores = []
      this.multiple_stores.forEach((i) => {
        this.selected_stores.push(i)
      })
    },
    toggleAll (checked) {
      if (checked) {
        this.ddl_district.Stores.forEach((i) => {
          var result = this.multiple_stores.map(function (item, index) {
            return item.ID
          }).indexOf(i.ID)
          if (result === -1) {
            this.multiple_stores.push(i)
          }
        })
      } else {
        this.ddl_district.Stores.forEach((i) => {
          var result = this.multiple_stores.map(function (item, index) {
            return item.ID
          }).indexOf(i.ID)
          if (result > -1) {
            this.multiple_stores.splice(result, 1)
          }
        })
      }
    },
    delStore (item) {
      var idx = this.selected_stores.indexOf(item)
      if (idx > -1) {
        this.selected_stores.splice(idx, 1)
      }
      var idx2 = this.multiple_stores.indexOf(item)
      if (idx2 > -1) {
        this.multiple_stores.splice(idx2, 1)
      }
    },
    getAllStores (s) {
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/marketing/getallstores/v1', {
        status: s
      })
        .then((response) => {
          this.$store.commit('TOKEN', response.data.jwt)
          this.$parent.Loading = false

          if (response.data.result === '0000') {
            this.stores = response.data.data
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            miniToastr.error(response.data.message, '門市資料讀取異常')
            console.log(response.data.message)
          }
        })
        .catch((error) => {
          this.$parent.Loading = false
          miniToastr.error(error, '門市資料讀取異常')
          console.log(error)
        })
        .finally(() => {
          if (this.store_type === 2) {
            this.selected_stores = this.storeListMk(this.StoreID)
          }
        })
    },
    getOneEventReward () {
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/marketing/getoneeventreward/v1', {
        id: this.id
      })
        .then((response) => {
          this.$store.commit('TOKEN', response.data.jwt)
          this.$parent.Loading = false

          if (response.data.result === '0000') {
            var item = response.data.data
            this.effect_type = item.EffectiveType
            this.design_date = this.old_design_date = this.dateFormat(item.DesignatedAt)
            this.effect_s_date = this.old_effect_s_date = this.dateFormat(item.StartAt)
            this.effect_e_date = this.dateFormat(item.EndAt)
            this.member_type = item.MemberType
            this.certain_amount = item.CertainAmount
            this.reward_bonus = item.RewardBonus
            this.multiple = item.Multiple
            this.store_type = item.StoreType
            this.StoreID = item.StoreID
            this.eventFuncValue = item.EventType
            // 複製的活動，若有複製折扣的都讓他預設在點數
            if (item.EventType === 1) {
              this.give_type = item.GiveType
            } else {
              this.eventFuncValue = 1 // 預設改為點數
              this.give_type = 1
            }
            if (item.GiveType === 3) {
              this.disA_certain_amount = item.DisCertainAmount
              this.disA_amount = item.Discount
            } else if (item.GiveType === 4) {
              this.disD_certain_amount = item.DisCertainAmount
              this.disD_sale = item.Discount
            }
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            miniToastr.error(response.data.message, '會員贈點活動讀取異常')
            console.log(response.data.message)
          }
        })
        .catch((error) => {
          this.$parent.Loading = false
          miniToastr.error(error, '會員贈點活動讀取異常')
          console.log(error)
        })
        .finally(() => {
          this.getAllStores(this.store_type)
        })
    },
    storeListMk (list) {
      var _s = list.split(',')
      var _mult = []
      var _sel = []
      this.stores.forEach(function (e) {
        var dist = e.Districts[0]
        if (dist.District === '全部區域') {
          dist.Stores.forEach(function (i) {
            var idx = _s.indexOf(i.ID.toString())
            if (idx > -1) {
              _mult.push(i)
              _sel.push(i)
            }
          })
        }
      })
      this.multiple_stores = _mult
      return _sel
    },
    dateFormat (date) {
      var _date = ''
      if (date && date.length === 8) {
        _date = date.substring(0, 4) + '-' + date.substring(4, 6) + '-' + date.substring(6, 8)
      }
      return _date
    },
    handleFileChange (e, i) {
      let inputDOM
      if (i === 1) {
        this.valid_cover_url = false
        inputDOM = this.$refs.inputer
        this.cover_file = inputDOM.files[0]
        this.$emit('input', this.cover_file)
        if (!this.imgPreview(this.cover_file, i)) {
          this.$refs.inputer.value = ''
          this.cover_url = undefined
        }
      } else {
        this.valid_content_url = false
        inputDOM = this.$refs.inputer2
        this.content_file = inputDOM.files[0]
        this.$emit('input', this.content_file)
        if (!this.imgPreview(this.content_file, i)) {
          this.$refs.inputer2.value = ''
          this.content_url = undefined
        }
      }
    },
    imgPreview (file, i) {
      var rtn = false
      let self = this
      if (!file || !window.FileReader) return
      if (/^image/.test(file.type)) {
        if (file.size > fileUploadMaxSize) {
          miniToastr.error('圖檔大小不可超過 5MB')
        } else {
          let reader = new FileReader()
          reader.readAsDataURL(file)
          reader.onloadend = function () {
            if (i === 1) {
              self.cover_url = this.result
            } else {
              self.content_url = this.result
            }
          }
          rtn = true
        }
      } else {
        miniToastr.error('請選擇正確圖檔')
      }
      return rtn
    }
  },
  watch: {
    link: function (val) {
      if (this.valid_errMsg) {
        if (!val) {
          this.valid_link = '活動網址為必填'
        } else if (!(this.link.substring(0, 7) === 'http://' || this.link.substring(0, 8) === 'https://')) {
          this.valid_link = '活動網址請輸入完整路徑http://或https://'
        } else {
          this.valid_link = ''
        }
      }
    },
    sdate: function (val) {
      if (this.valid_errMsg) {
        if (!val) {
          this.valid_sdate = '日期格式不正確'
        } else if (val < this.today) {
          this.valid_sdate = '開始日期不得小於系統時間'
        } else {
          this.valid_sdate = ''
        }
      }
    },
    edate: function (val) {
      if (this.valid_errMsg) {
        if (!val) {
          this.valid_edate = '日期格式不正確'
        } else if (val < this.sdate) {
          this.valid_edate = '結束日期不得小於開始日期'
        } else {
          this.valid_edate = ''
        }
      }
    },
    design_date: function (val) {
      if (this.valid_errMsg) {
        if (!val) {
          this.valid_design_date = '日期格式不正確'
        } else if (val < this.sdate || val > this.edate) {
          this.valid_design_date = '生效日期不得超出活動日期區間'
        } else {
          this.valid_design_date = ''
        }
      }
    },
    effect_s_date: function (val) {
      if (this.valid_errMsg) {
        if (!val) {
          this.valid_effect_s_date = '日期格式不正確'
        } else if (val < this.sdate || val > this.edate) {
          this.valid_effect_s_date = '生效開始日不得超出活動日期區間'
        } else {
          this.valid_effect_s_date = ''
        }
      }
    },
    effect_e_date: function (val) {
      if (this.valid_errMsg) {
        if (!val) {
          this.valid_effect_e_date = '日期格式不正確'
        } else if (val < this.effect_s_date) {
          this.valid_effect_e_date = '生效結束日不得小於開始日期'
        } else if (val > this.edate) {
          this.valid_effect_e_date = '生效結束日不得超出活動日期區間'
        } else {
          this.valid_effect_e_date = ''
        }
      }
    },
    certain_amount: function (val) {
      if (val < 0 || !val) {
        this.certain_amount = 0
      } else if (val > 9999) {
        this.certain_amount = 9999
      } else {
        this.certain_amount = parseInt(val)
      }
      if (this.valid_errMsg && val > 0 && this.reward_bonus > 0) this.valid_bonus = ''
    },
    reward_bonus: function (val) {
      if (val < 0 || !val) {
        this.reward_bonus = 0
      } else if (val > 9999) {
        this.reward_bonus = 9999
      } else {
        this.reward_bonus = parseInt(val)
      }
      if (this.valid_errMsg && val > 0 && this.certain_amount > 0) this.valid_bonus = ''
    },
    multiple: function (val) {
      if (val < 0 || !val) {
        this.multiple = 0
      } else if (val > 9999) {
        this.multiple = 9999
      } else {
        this.multiple = parseInt(val)
      }
      if (this.valid_errMsg && val > 0) this.valid_bonus = ''
    },
    disA_certain_amount: function (val) {
      if (val < 0 || !val) {
        this.disA_certain_amount = 0
      } else if (val > 9999) {
        this.disA_certain_amount = 9999
      } else {
        this.disA_certain_amount = parseInt(val)
      }
      if (this.valid_errMsg && val > 0 && this.disA_amount > 0) this.valid_bonus = ''
    },
    disA_amount: function (val) {
      if (val < 0 || !val) {
        this.disA_amount = 0
      } else if (val > 9999) {
        this.disA_amount = 9999
      } else {
        this.disA_amount = parseInt(val)
      }
      if (this.valid_errMsg && val > 0 && this.disA_certain_amount > 0) this.valid_bonus = ''
    },
    disD_certain_amount: function (val) {
      if (val < 0 || !val) {
        this.disD_certain_amount = 0
      } else if (val > 9999) {
        this.disD_certain_amount = 9999
      } else {
        this.disD_certain_amount = parseInt(val)
      }
      if (this.valid_errMsg && val > 0 && this.disD_sale > 0) this.valid_discount = ''
    },
    disD_sale: function (val) {
      if (val < 0 || !val) {
        this.disD_sale = 0
      } else if (val > 1) {
        this.disD_sale = 1
      } else {
        this.disD_sale = parseFloat(val)
      }
      if (this.valid_errMsg && val > 0 && this.disD_certain_amount > 0) this.valid_discount = ''
    }
  }
}
</script>

<style scoped>
.upload_block {
  position: relative;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  background: #f1f1f1;
  border: 3px dashed #d6d4d4;
}
.pic {
  width: 260px;
  height: 180px;
}
.pic2 {
  width: 180px;
  height: 180px;
}
.upload_input {
  display: none;
}
.upload_img {
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 2;
}
.upload_icon {
  font-weight: bold;
  font-size: 200%;
  position: absolute;
  z-index: 1;
  left: 0;
  width: 100%;
  top: 35%;
}
fieldset {
  padding: 8px 22px 18px;
  margin: 0 2px 5px;
  border: 1px solid silver;
}
legend {
  padding: .2em;
  border: 0;
  width: auto;
}
.my-scrollbar {
  width: 35%;
  height: 240px;
  min-width: 100%;
  overflow: auto;
}
.box1color {
  margin: auto;
  border: 1px solid silver;
}
</style>



// WEBPACK FOOTER //
// src/pages/marketing/event/Edit.vue